import angular from 'angular';

angular.module('vrm.core')
    .service('LoginService', LoginService);


export class AuthenticationResult {
    /** @type Boolean */
    success = false;
    /** @type {'password'|'sms'|'mobile'} */
    mfaMode = 'password';
    /** @type Boolean */
    mfaStarted = false;
    /** @type Boolean */
    mfaFailure = false;

    constructor(props) {
        Object.keys(props).forEach(key => this[key] = props[key]);
    }

    get mfaRequired() {
        return this.mfaMode !== 'password';
    }

    static createSuccess() {
        return new AuthenticationResult({success: true});
    }

    static createFailure() {
        return new AuthenticationResult({success: false});
    }

    static createMfaStarted(mfaMode) {
        return new AuthenticationResult({success: false, mfaMode, mfaStarted: true, mfaFailure: false});
    }

    static createMfaFailure(mfaMode) {
        return new AuthenticationResult({success: false, mfaMode, mfaStarted: false, mfaFailure: true});
    }
}

/**
 * @constructor
 * @ngInject
 */
function LoginService($log, ApiService, jwtHelper, localStorageService, vrmNotificationsService, vrmNotificationType, locale) {
    const service = {
        loginModel: {
            username: '',
            password: '',
            sms_token: null,
            remember_me: false,
            language: ''
        },
        login,
    };

    let notificationId;

    function notifyError(message) {
        notificationId = vrmNotificationsService.add({
            type: vrmNotificationType.ERROR,
            message: message + ' (1512)'
        })
    }

    /**
     * Call login function on API
     * @return promise
     */
    async function login() {
        // clear existing messages
        vrmNotificationsService.remove(notificationId);
        try {
            const sentWithMfaCode = !!service.loginModel.sms_token;
            const {data} = await ApiService.auth('/login', service.loginModel);

            if (typeof data.token === 'string' && data.token.length) {
                localStorageService.set("token", data.token);

                return AuthenticationResult.createSuccess();
            }

            // Login failed, check for MFA status
            if ('verification_mode' in data) {
                const mfaMode = data.verification_mode;
                const started = data.verification_sent;
                if (sentWithMfaCode) {
                    // MFA code was sent, so the code was invalid
                    notifyError(locale.getString('login.twostep_code_wrong'));
                    return AuthenticationResult.createMfaFailure(mfaMode);
                } else if (started) {
                    // MFA code not sent and sequence started
                    return AuthenticationResult.createMfaStarted(mfaMode);
                } else {
                    // MFA code not sent, then third-party must have failed
                    notifyError(locale.getString('login.verification_failed'));
                    return AuthenticationResult.createMfaFailure(mfaMode);
                }
            }

            // Login failed, check for a message from the api
            notifyError(data.message ? data.message : locale.getString('login.login_failed'));
        } catch {
            // Empty on purpose
        }
        // The only result possible is failure
        return AuthenticationResult.createFailure();
    }

    return service;
}
